<script lang="ts">
  import { onMount } from "svelte";
  import { apiClient } from "./apiClient";
  import type { FlatOrderModel } from "./apiClient";
  import Order from "./Order.svelte";
  import type { OrderData } from "./stores";
  import { attendantName } from "./stores";

  import { toast } from "@zerodevx/svelte-toast";
  // define the data holding variable
  let allOrders: FlatOrderModel[] = [];
  let orders: OrderData[] = [];

  $: orders =
    allOrders.map((order) => ({
      ...order,
      selected: order.attendant === $attendantName,
    }));

  onMount(() => {
    (async () => {
      // instant first time fetch
      // closure magic because onmount can't be async
      // https://svelte.dev/docs/svelte/lifecycle-hooks
      allOrders = await apiClient.getOrders();
    })();

    const interval = setInterval(async () => {
      allOrders = await apiClient.getOrders();
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });

  const updateOrder = (update: FlatOrderModel) => {
    const existingId = allOrders.findIndex(
      (existingOrder) => existingOrder.id === update.id
    );
    if (existingId !== -1) {
      allOrders[existingId] = update;
      allOrders = [...allOrders];
    }
  };

  const handleOrderSelected = async (order: OrderData) => {
    toast.push(`Du bearbeitest jetzt Bestellung #${order.id}`);

    updateOrder(await apiClient.acceptOrderAs(order.id, $attendantName));
  };

  const handleOrderFulfilled = async (order: OrderData) => {
    toast.push(`Du hast Bestellung #${order.id} erfüllt`);

    updateOrder(await apiClient.finishOrder(order.id));
  };

  const handleOrderTakeover = async (order: OrderData) => {
    toast.push(
      `Du hast Bestellung #${order.id} von ${order.attendant} übernommen`
    );

    updateOrder(await apiClient.acceptOrderAs(order.id, $attendantName));
  };

  const handleOrderUnselected = async (order: OrderData) => {
    toast.push(`Du bearbeitest Bestellung #${order.id} nicht mehr`);

    updateOrder(await apiClient.unacceptOrder(order.id));
  };
</script>

{#if orders}
  <ol>
    {#each orders as order}
      <Order
        {order}
        on:selected={() => handleOrderSelected(order)}
        on:unselected={() => handleOrderUnselected(order)}
        on:fulfilled={() => handleOrderFulfilled(order)}
        on:takeover={() => handleOrderTakeover(order)}
      />
    {/each}
  </ol>
{:else}
  <p class="loading">loading...</p>
{/if}

<style>
  ol {
    flex: 1;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: space-around;
    background-color: lavender;
    list-style: none;
    padding-left: 0;
    margin: 0;
  }
</style>
